import { CurrentUser } from 'libs/hooks/useCurrentUser';

// ABI message send/receive through the CBMS work order UI is restricted to
// specific users. Rather than hardcoding individual identities (which would ship
// in the JS bundle and require a code change per membership update), access is
// derived from a dedicated tag on the operator user record. Whoever is granted
// this tag gains access — membership is managed as data (a tag on the user), so
// no code change is needed to add/remove users. Note the UI check only controls
// menu visibility (UX); the authoritative authorization is enforced by the
// backend (XbcbMessageExchangeAuthorityService).
export const ABI_MESSAGE_ACCESS_TAG_KEY = 'CBMS_ABI_MESSAGE_ACCESS';
export const ABI_MESSAGE_ACCESS_TAG_VALUE = 'enabled';

/**
 * Determines whether the current user is allowed to send/receive ABI messages
 * through the CBMS work order UI, based on a dedicated tag on the user record.
 * @param {CurrentUser} currentUser - the currently authenticated user
 * @return {boolean} true if the user has the ABI message access tag
 */
export const isAbiMessageAuthorizedUser = (
  currentUser: CurrentUser,
): boolean => {
  const tags: { key?: string; value?: string }[] = currentUser?.tags ?? [];
  return tags.some(
    ({ key, value }) =>
      key === ABI_MESSAGE_ACCESS_TAG_KEY &&
      value === ABI_MESSAGE_ACCESS_TAG_VALUE,
  );
};
